var _defs, _path, _path2, _path3, _g, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 69.368,
    height: 100.584,
    viewBox: "0 0 69.368 100.584",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#e3e4d8;}.b{fill:#d0cebd;}.c{fill:#2f9171;}.d{fill:#a09893;}.e{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M69.368,95.668H0V0H53.761L69.368,15.655Zm0,0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M273.656,0V14.747H288.4Zm0,0",
    transform: "translate(-219.034)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M0,353.1H69.368V382.6H0Zm0,0",
    transform: "translate(0 -282.011)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.192 23.305)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M57.245,124.589H45.775a1.639,1.639,0,0,1-1.639-1.638V116.4a1.64,1.64,0,0,1,1.639-1.639h11.47a1.639,1.639,0,0,1,1.639,1.639v6.554A1.639,1.639,0,0,1,57.245,124.589Zm-9.831-3.276h8.192v-3.277H47.414Zm0,0",
    transform: "translate(-44.137 -114.758)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M119.038,124.589h-11.47a1.639,1.639,0,0,1-1.639-1.638V116.4a1.64,1.64,0,0,1,1.639-1.639h11.47a1.639,1.639,0,0,1,1.639,1.639v6.554A1.639,1.639,0,0,1,119.038,124.589Zm-9.831-3.276H117.4v-3.277h-8.192Zm0,0",
    transform: "translate(-93.184 -114.758)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M180.831,124.589h-11.47a1.639,1.639,0,0,1-1.639-1.638V116.4a1.64,1.64,0,0,1,1.639-1.639h11.47a1.639,1.639,0,0,1,1.639,1.639v6.554A1.639,1.639,0,0,1,180.831,124.589ZM171,121.312h8.192v-3.277H171Zm0,0",
    transform: "translate(-142.232 -114.758)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M242.624,124.589h-11.47a1.639,1.639,0,0,1-1.639-1.638V116.4a1.64,1.64,0,0,1,1.639-1.639h11.47a1.639,1.639,0,0,1,1.639,1.639v6.554A1.639,1.639,0,0,1,242.624,124.589Zm-9.831-3.276h8.192v-3.277h-8.192Zm0,0",
    transform: "translate(-191.279 -114.758)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M57.245,159.9H45.775a1.64,1.64,0,0,1-1.639-1.639v-6.554a1.639,1.639,0,0,1,1.639-1.639h11.47a1.639,1.639,0,0,1,1.639,1.639v6.554A1.639,1.639,0,0,1,57.245,159.9Zm-9.831-3.277h8.192v-3.277H47.414Zm0,0",
    transform: "translate(-44.137 -143.516)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M119.038,159.9h-11.47a1.64,1.64,0,0,1-1.639-1.639v-6.554a1.639,1.639,0,0,1,1.639-1.639h11.47a1.639,1.639,0,0,1,1.639,1.639v6.554A1.639,1.639,0,0,1,119.038,159.9Zm-9.831-3.277H117.4v-3.277h-8.192Zm0,0",
    transform: "translate(-93.184 -143.516)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M180.831,159.9h-11.47a1.64,1.64,0,0,1-1.639-1.639v-6.554a1.639,1.639,0,0,1,1.639-1.639h11.47a1.639,1.639,0,0,1,1.639,1.639v6.554A1.639,1.639,0,0,1,180.831,159.9ZM171,156.624h8.192v-3.277H171Zm0,0",
    transform: "translate(-142.232 -143.516)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M242.624,159.9h-11.47a1.64,1.64,0,0,1-1.639-1.639v-6.554a1.639,1.639,0,0,1,1.639-1.639h11.47a1.639,1.639,0,0,1,1.639,1.639v6.554A1.639,1.639,0,0,1,242.624,159.9Zm-9.831-3.277h8.192v-3.277h-8.192Zm0,0",
    transform: "translate(-191.279 -143.516)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M57.245,195.21H45.775a1.639,1.639,0,0,1-1.639-1.639v-6.554a1.64,1.64,0,0,1,1.639-1.639h11.47a1.639,1.639,0,0,1,1.639,1.639v6.554A1.639,1.639,0,0,1,57.245,195.21Zm-9.831-3.277h8.192v-3.277H47.414Zm0,0",
    transform: "translate(-44.137 -172.271)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M119.038,195.21h-11.47a1.639,1.639,0,0,1-1.639-1.639v-6.554a1.64,1.64,0,0,1,1.639-1.639h11.47a1.639,1.639,0,0,1,1.639,1.639v6.554A1.639,1.639,0,0,1,119.038,195.21Zm-9.831-3.277H117.4v-3.277h-8.192Zm0,0",
    transform: "translate(-93.184 -172.271)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M180.831,195.21h-11.47a1.639,1.639,0,0,1-1.639-1.639v-6.554a1.64,1.64,0,0,1,1.639-1.639h11.47a1.639,1.639,0,0,1,1.639,1.639v6.554A1.639,1.639,0,0,1,180.831,195.21ZM171,191.933h8.192v-3.277H171Zm0,0",
    transform: "translate(-142.232 -172.271)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M242.624,195.21h-11.47a1.639,1.639,0,0,1-1.639-1.639v-6.554a1.64,1.64,0,0,1,1.639-1.639h11.47a1.639,1.639,0,0,1,1.639,1.639v6.554A1.639,1.639,0,0,1,242.624,195.21Zm-9.831-3.277h8.192v-3.277h-8.192Zm0,0",
    transform: "translate(-191.279 -172.271)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M57.245,230.522H45.775a1.64,1.64,0,0,1-1.639-1.639v-6.554a1.639,1.639,0,0,1,1.639-1.638h11.47a1.639,1.639,0,0,1,1.639,1.638v6.554A1.639,1.639,0,0,1,57.245,230.522Zm-9.831-3.277h8.192v-3.277H47.414Zm0,0",
    transform: "translate(-44.137 -201.029)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M119.038,230.522h-11.47a1.64,1.64,0,0,1-1.639-1.639v-6.554a1.639,1.639,0,0,1,1.639-1.638h11.47a1.639,1.639,0,0,1,1.639,1.638v6.554A1.639,1.639,0,0,1,119.038,230.522Zm-9.831-3.277H117.4v-3.277h-8.192Zm0,0",
    transform: "translate(-93.184 -201.029)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M180.831,230.522h-11.47a1.64,1.64,0,0,1-1.639-1.639v-6.554a1.639,1.639,0,0,1,1.639-1.638h11.47a1.639,1.639,0,0,1,1.639,1.638v6.554A1.639,1.639,0,0,1,180.831,230.522ZM171,227.245h8.192v-3.277H171Zm0,0",
    transform: "translate(-142.232 -201.029)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M242.624,230.522h-11.47a1.64,1.64,0,0,1-1.639-1.639v-6.554a1.639,1.639,0,0,1,1.639-1.638h11.47a1.639,1.639,0,0,1,1.639,1.638v6.554A1.639,1.639,0,0,1,242.624,230.522Zm-9.831-3.277h8.192v-3.277h-8.192Zm0,0",
    transform: "translate(-191.279 -201.029)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M57.245,265.831H45.775a1.639,1.639,0,0,1-1.639-1.639v-6.554A1.639,1.639,0,0,1,45.775,256h11.47a1.639,1.639,0,0,1,1.639,1.639v6.554A1.639,1.639,0,0,1,57.245,265.831Zm-9.831-3.277h8.192v-3.276H47.414Zm0,0",
    transform: "translate(-44.137 -229.784)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M119.038,265.831h-11.47a1.639,1.639,0,0,1-1.639-1.639v-6.554A1.639,1.639,0,0,1,107.568,256h11.47a1.639,1.639,0,0,1,1.639,1.639v6.554A1.639,1.639,0,0,1,119.038,265.831Zm-9.831-3.277H117.4v-3.276h-8.192Zm0,0",
    transform: "translate(-93.184 -229.784)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M180.831,265.831h-11.47a1.639,1.639,0,0,1-1.639-1.639v-6.554A1.639,1.639,0,0,1,169.361,256h11.47a1.639,1.639,0,0,1,1.639,1.639v6.554A1.639,1.639,0,0,1,180.831,265.831ZM171,262.554h8.192v-3.276H171Zm0,0",
    transform: "translate(-142.232 -229.784)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M242.624,265.831h-11.47a1.639,1.639,0,0,1-1.639-1.639v-6.554A1.639,1.639,0,0,1,231.154,256h11.47a1.639,1.639,0,0,1,1.639,1.639v6.554A1.639,1.639,0,0,1,242.624,265.831Zm-9.831-3.277h8.192v-3.276h-8.192Zm0,0",
    transform: "translate(-191.279 -229.784)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M55.606,399.248H49.067a4.936,4.936,0,0,1-4.93-4.93v-9.8a4.936,4.936,0,0,1,4.93-4.93h6.539a1.639,1.639,0,1,1,0,3.277H49.067a1.655,1.655,0,0,0-1.653,1.653v9.8a1.655,1.655,0,0,0,1.653,1.654h6.539a1.638,1.638,0,1,1,0,3.276Zm0,0",
    transform: "translate(-35.944 -303.58)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M139.787,399.248h-5.734a1.638,1.638,0,1,1,0-3.276h5.734a2.458,2.458,0,1,0,0-4.916h-1.639a5.735,5.735,0,0,1,0-11.47h5.735a1.639,1.639,0,0,1,0,3.277h-5.735a2.458,2.458,0,0,0,0,4.915h1.639a5.735,5.735,0,1,1,0,11.47Zm0,0",
    transform: "translate(-106.042 -303.58)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M228.877,399.247a1.642,1.642,0,0,1-1.523-1.029L220.8,381.834a1.639,1.639,0,0,1,3.043-1.217l5.033,12.582,5.032-12.582a1.638,1.638,0,1,1,3.042,1.217L230.4,398.218A1.637,1.637,0,0,1,228.877,399.247Zm0,0",
    transform: "translate(-175.894 -303.579)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.1c2b7689639b1c39509f23844ec2c0d5.svg";
export { ForwardRef as ReactComponent };